/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_BathroomInputs */

const cs_enum_bathroom = /** @type {(inputs: Enum_BathroomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koupelna`)
};

const en_enum_bathroom = /** @type {(inputs: Enum_BathroomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bathroom`)
};

/**
* | output |
* | --- |
* | "Bathroom" |
*
* @param {Enum_BathroomInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_bathroom = /** @type {((inputs?: Enum_BathroomInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_BathroomInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_bathroom(inputs)
	return cs_enum_bathroom(inputs)
});